import { useState } from 'react';

import PropTypes from 'prop-types';

import { Alert, Box, Button, Dialog } from '@mui/material';
import dayjs from 'dayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers';

import {
  BtnActionsDlgAsk, ContentSectionDialog, TitleSectionDialog,
} from '../assets/styles/admin-dashboard.dialog.styles';
import ProvidersService from '../../core/services/providers.service';

const DialogEditPaymentStartDate = ({
  data,
  openDialog,
  setOpenDialog,
  onEditSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [error, setErrror] = useState(false);
  const [paymentAgreementDate, setPaymentAgreementDate] = useState(dayjs(data?.agreementStartDate));

  const providerService = new ProvidersService();

  const editPayment = async (id) => {
    try {
      setLoading(true);
      await providerService.updatePaymentStartDate(id, {
        "new_agreement_date": paymentAgreementDate
      })
      .finally(() => {
        onEditSuccess();
        setOpenDialog(false);
        setLoading(false);
      })
    } catch (error) {
      setErrror(true);
      console.log(error);
    }
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  return (
    <>
      <Dialog
        open={openDialog}
        keepMounted
        onClose={handleDialogClose}
        PaperProps={{ sx: { padding: '16px' } }}
      >
        <TitleSectionDialog>{data?.name}</TitleSectionDialog>
        <ContentSectionDialog>
          <Box sx={{ mb: 2 }}>
            Edit payment agreement date
          </Box>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            label="Payment agreement date"
            value={paymentAgreementDate}
            onChange={(newValue) => setPaymentAgreementDate(newValue)}
          />
          </LocalizationProvider>
        </ContentSectionDialog>
        {error && <Alert severity="warning">Fail to edit, try again.</Alert>}
        <BtnActionsDlgAsk>
          <Button
            variant='outlined'
            color='secondary'
            onClick={() => {
              handleDialogClose();
            }}
          >
            Cancel
          </Button>
          <Button
            disabled={loading}
            variant='outlined'
            color='primary'
            onClick={() => {
              editPayment(data.agreementId);
            }}
          >
            Edit
          </Button>
        </BtnActionsDlgAsk>
      </Dialog>
    </>
  );
};

export default DialogEditPaymentStartDate;

DialogEditPaymentStartDate.propTypes = {
  data: PropTypes.shape({
    agreementId: PropTypes.number,
    name: PropTypes.string,
    agreementStartDate: PropTypes.string,
  }),
  openDialog: PropTypes.bool,
  setOpenDialog: PropTypes.func,
  onEditSuccess: PropTypes.func.isRequired,
};
